import { TRANSACTION_ID_KEY, ORDER_ID_KEY, CANCEL_ID_KEY, FAILED_TRANSACTION_ID_KEY } from 'legacy/constants/storageKeys';
import { LocalStorageManager } from 'legacy/utils/LocalStorageManager';

export const cleanOrderData = () => {
  LocalStorageManager.removeItem(TRANSACTION_ID_KEY);
  LocalStorageManager.removeItem(FAILED_TRANSACTION_ID_KEY);
  LocalStorageManager.removeItem(CANCEL_ID_KEY);
  LocalStorageManager.removeItem(ORDER_ID_KEY);
};
